import experimentFlags, { VIRTUAL_EVENTS } from '../../../../util/experimentFlags';

const prodUsers = [
  'jwang@zola.com',
  'zolatest3@gmail.com',
  'cgraves@zola.com',
  'vvillalba-x@zola.com',
  'slim@zola.com',
  'mevar@zola.com',
  'atoris@zola.com',
  'rwilson@zola.com',
  'pcoyle@zola.com',
  'wtso@gzola.com',
  'zolatesting@zola.com',
  'wtso1993@gmail.com',
  'verolara19@gmail.com',
];

function isInProdTest(userContext) {
  const { email } = userContext;
  if (prodUsers.indexOf(email) > -1) {
    return true;
  }
  return false;
}

export default function isVirtualEvents(userContext) {
  const userInProdTest = isInProdTest(userContext);
  return experimentFlags.getFlag(VIRTUAL_EVENTS, userContext) || userInProdTest;
}



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/util/isVirtualEvents.js